import "element-internals-polyfill";
import "construct-style-sheets-polyfill";
import "smoothscroll-polyfill";
import "./scripts/search.js";
import "./scripts/ac101-autocomplete-input.js";
import "./scripts/ac101-filters-button.js";
import "./scripts/ac101-filters-bar.js";
import "./scripts/ac101-search-box.js";
import "./scripts/ac101-select-all.js";
import "./scripts/ac101-checkbox.js";
import "./scripts/ac101-operators.js";
import "./scripts/ac101-youtube.js";
import "./scripts/ac101-tooltip.js";
import "./scripts/ac101-app.js";
import "./scripts/ac101-search-modal-form.js";
import "./scripts/ac101-filters-modal.js";
import "./scripts/ac101-hccalculator.js";
import "./scripts/ac101-accalculator.js";

import "./scripts/ac101-shortlist-button.js";
import "./scripts/ac101-shortlist-count.js";


import "./scripts/ac101-enquiry-modal-content.js";



import { Tab } from "bootstrap";
const element = document.querySelector("#filters-modal-select");

if (element) {
  element.addEventListener("change", (e) => {
    const target = e.target as HTMLSelectElement;
    const tab = document.querySelector("#" + target.value);
    Tab.getOrCreateInstance(tab)?.show();
  });
}
